import axios from 'axios';
import getHeaders from '../../constants/headers';
import { CONSUMER_BASE_URL, STORE_BASE_URL } from '../BaseURL';

export const customerAddressGet = (id, storeId) => {
    return axios({
      method: 'get',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        id +
        '/address', // for android use
      headers: getHeaders(),
    });
  };
  
  export const customerUpdate = data => {
    return axios({
      method: 'put',
      url:
        CONSUMER_BASE_URL + `/api/secure/v1/store/${data.storeId}/store-customer`,
      headers: getHeaders(),
      data: JSON.stringify(data),
    });
  };

  
export const customerAddressCreate = (id, storeId, address) => {
    return axios({
      method: 'post',
      url:
        CONSUMER_BASE_URL +
        '/api/secure/v1/store/' +
        storeId +
        '/store-customer/' +
        id +
        '/address', // for android use
      headers: getHeaders(),
      data: JSON.stringify(address),
    });
  };
  